function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".references-cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.references-cls-1,.references-cls-2{stroke:#2e4150;}.references-cls-2{fill:#2e4150;stroke-miterlimit:10;stroke-width:0.75px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("polygon", {
  className: "references-cls-1",
  points: "25 9.44 25 1 16.56 1 9.44 1 1 1 1 9.44 1 16.56 1 25 9.44 25 16.56 25 25 25 25 16.56 25 9.44"
}), React.createElement("path", {
  className: "references-cls-2",
  d: "M17.82,6.43H9.52A1.74,1.74,0,0,0,8.2,7a1.89,1.89,0,0,0-.54,1.27v9.47a1.81,1.81,0,0,0,1.86,1.88h8.3a.51.51,0,0,0,.52-.52V7A.52.52,0,0,0,17.82,6.43Zm-.51,12.12H9.52a.78.78,0,0,1-.83-.84.79.79,0,0,1,.83-.83h7.79Zm0-2.7H9.52a2,2,0,0,0-.83.17V8.31a.93.93,0,0,1,.23-.62.82.82,0,0,1,.6-.23h7.79Z"
}), React.createElement("path", {
  className: "references-cls-2",
  d: "M10.73,10.12h4.39a.52.52,0,0,0,0-1H10.73a.51.51,0,0,0-.52.52A.52.52,0,0,0,10.73,10.12Z"
}), React.createElement("path", {
  className: "references-cls-2",
  d: "M10.73,12.53h4.39a.52.52,0,0,0,0-1H10.73a.51.51,0,0,0-.52.52A.52.52,0,0,0,10.73,12.53Z"
})));

var SvgReferences = function SvgReferences(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReferences, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/references.b59beeb6.svg";
export { ForwardRef as ReactComponent };